import React, { useEffect }  from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import Swal from 'sweetalert2'
import { useFormik } from 'formik';
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';

const validationSchema = yup.object({
    name: yup.string('Enter your admin name').required('Admin Name is required'),
    organizationName: yup.string('Enter your company name').required('Company Name is required'),
    email: yup
      .string('Enter your email')
      .email('Enter a valid email')
      .matches(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,'Enter a valid email')
      .required('Email is required'),
    phone: yup.string().matches(/^\d{10}$/, 'Enter valid phone number')
        .nullable()
        .notRequired()
        .min(10, "Must be more than 10 characters")
        .max(20, "Must be less than 20 characters")
});

export const AddUser = ({type, getList, editId, setEditId, show, setShow, ...rest}) => {

    const handleClose = () => setShow(false);
    const initialValues = {
        id: editId,
        name: '',
        email: '',
        organizationName: '',
        phone: '',
    }
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        }
    });
    const handleSubmit = (values) =>{
        if(editId > 0){
            axios.put(`api/users/update`, values).then(res => {                
                setEditId(0)
                setShow(false)
                if(res.data.success){
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        getList();
                    })
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                setShow(false)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }
        else{
            axios.post(`api/users/create`, values).then(res => {
                setShow(false)
                if(res.data.success){
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        formik.resetForm();
                        getList();
                    })                
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                setShow(false)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }        
    }
    
    useEffect(() => {
        getList();
        if(editId > 0){
            axios.get(`api/user?id=${editId}`).then(res => {
                if(res.data.success){
                    formik.setFieldValue('id', res.data.data.id)
                    formik.setFieldValue('name', res.data.data.name)
                    formik.setFieldValue('email', res.data.data.email)
                    formik.setFieldValue('organizationName', res.data.data.organizationName)
                    formik.setFieldValue('phone', res.data.data.phone)
                }
            })
        }
        else{
            formik.resetForm();
        }
        
    },[editId]);

    const handlePopupClose = () => {
        formik.resetForm();
        handleClose()
    }
    return (
        <Modal show={show} onHide={handlePopupClose}>
            <Modal.Header closeButton>
            <Modal.Title>{type} Admin</Modal.Title>
            </Modal.Header>
            <form onSubmit={formik.handleSubmit}>
                <Modal.Body>  
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="basic-icon-default-name">Admin Name</label>
                                <div className="input-group input-group-merge">
                                    <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                    <input name="name" type="text" className="form-control" id="basic-icon-default-name" placeholder="Rajiv Doe" aria-label="Rajiv Doe" aria-describedby="basic-icon-default-fullname2" 
                                    value={formik.values.name} 
                                    onChange={formik.handleChange} 
                                    onBlur={formik.handleBlur}/>
                                </div>
                                {formik.touched.name && formik.errors.name && (
                                    <div className="text-danger">{formik.errors.name}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="basic-icon-default-name">Company Name</label>
                                <div className="input-group input-group-merge">
                                    <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-building"></i></span>
                                    <input name="organizationName" type="text" className="form-control" id="basic-icon-default-name" placeholder="Company" aria-label="Company" aria-describedby="basic-icon-default-fullname2" 
                                    value={formik.values.organizationName} 
                                    onChange={formik.handleChange} 
                                    onBlur={formik.handleBlur}/>
                                </div>
                                {formik.touched.organizationName && formik.errors.organizationName && (
                                    <div className="text-danger">{formik.errors.organizationName}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="basic-icon-default-email">Email</label>
                                <div className="input-group input-group-merge">
                                    <span className="input-group-text"><i className="bx bx-envelope"></i></span>
                                    <input name="email" type="text" id="basic-icon-default-email" className="form-control" placeholder="Rajiv.doe@example.com" aria-label="Rajiv.doe@example.com" aria-describedby="basic-icon-default-email2" 
                                    value={formik.values.email} 
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}/>
                                </div>
                                {formik.touched.email && formik.errors.email && (
                                    <div className="text-danger">{formik.errors.email}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="basic-icon-default-phone">Phone No</label>
                                <div className="input-group input-group-merge">
                                    <span id="basic-icon-default-phone2" className="input-group-text"><i className="bx bx-phone"></i></span>
                                    <input name="phone" type="text" id="basic-icon-default-phone" className="form-control phone-mask" placeholder="658 799 8941" aria-label="658 799 8941" aria-describedby="basic-icon-default-phone2"
                                    value={formik.values.phone}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur} />
                                </div>
                                {formik.touched.phone && formik.errors.phone && (
                                    <div className="text-danger">{formik.errors.phone}</div>
                                )}
                            </div>
                        </div>
                    </div> 
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" onClick={handlePopupClose}>Close</button>
                    <button type="submit" className="btn btn-primary">{type == 'Add' ? 'Add' : 'Update'}</button>
                </Modal.Footer>
            </form>
        </Modal>
    )
}
export default AddUser;
AddUser.propTypes = {
    type: PropTypes.string.isRequired,  
};